import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { redirectToNotFoundPageIf404, ReferencesService, RouteActions } from 'core';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';

@Injectable()
export class NeedOpenCONF01V2RouteGuard implements CanActivate {
    constructor(private routeActions: RouteActions, private referencesService: ReferencesService) {}

    public canActivate(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        const idParamName = 'id';
        const paramMap = route.children[0].paramMap;
        if (paramMap.keys.length !== 1 || !paramMap.has(idParamName)) {
            return true;
        }
        const correlationId = paramMap.get(idParamName);
        if (correlationId) {
            return this.referencesService.getBPCodeOfRequest(correlationId).pipe(
                redirectToNotFoundPageIf404(this.routeActions),
                map(bpCode => bpCode === 'CONF01V2'),
                tap(needOpenCONF01V2 => {
                    if (!needOpenCONF01V2) {
                        const conf01Url = `conf01dcs/${correlationId}`;
                        this.routeActions.navigate([conf01Url]);
                    }
                })
            );
        }
        return true;
    }
}
